import React from 'react';
import cx from 'classnames';
import { Box } from '../Box';
import { Rank } from '../Rank';
import { Text, TextAnchor } from '../Text';
import { PageRankSummaryProps } from './types';

export const PageRankSummary = ({
  position,
  title,
  url,
}: PageRankSummaryProps) => {
  const href = url.indexOf('http') === 0 ? url : `https://${url}`;
  return (
    <Box className="grid grid-cols-[max-content_1fr] gap-4 items-center">
      <Rank size={38} value={position} />
      <Box className="w-full overflow-hidden">
        {title && (
          <Text as="p" className="truncate">
            {title}
          </Text>
        )}
        <TextAnchor
          href={href}
          className={cx([
            'w-min',
            'max-w-full',
            'flow-root',
            'truncate',
            'hover:underline',
          ])}
          data-mms--outbound-action="page-summary-link"
        >
          {url}
        </TextAnchor>
      </Box>
    </Box>
  );
};
